exports.env = function () {
  return {
    // 开发环境变量
    // 修改BASE_API需要重跑
    development: {
      BASE_API: 'https://shaoguan.iot-cn.com.cn',
      // BASE_API: 'http://127.0.0.1:10002',
      // BASE_API: 'http://8.140.155.218:17000',
      // BASE_API: 'http://192.168.99.189:8080',
      // BASE_API: 'http://192.168.99.183:8080',
      // BASE_API: 'http://192.168.99.181:8080',
      // BASE_API: 'http://localhost:8081',
      // BASE_API: 'http://agwua9.natappfree.cc',
      // BASE_API: 'http://182.92.208.167:8082',
      // BASE_API: 'https://iottest.yuankonginfo.com',
      // BASE_API: 'http://192.168.227.233:8080',
      // WEBSOCKET: 'wss://shaoguan.iot-cn.com.cn/websocket',
      WEBSOCKET: 'ws://127.0.0.1:10002/websocket',
      // WEBSOCKET: 'ws://192.168.99.182:19977/websocket',
      // IMAGE_PREFIX: 'http://39.106.142.104/'
      IMAGE_PREFIX: 'http://127.0.0.1:10002/'
    },
    // 生产环境变量
    production: {
      BASE_API: 'https://shaoguan.iot-cn.com.cn',
      // BASE_API: 'http://192.168.99.182:19998',
      IMAGE_PREFIX: 'http://39.106.142.104/',
      WEBSOCKET: 'wss://shaoguan.iot-cn.com.cn/websocket',
    }
  }
}
